// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorsSection__error--sJX0D"};